/**
 * Cihaz saati ↔ sunucu saati offset hesaplayıcı (EWMA).
 *
 * RPi gibi RTC'siz cihazlarda sistem saati ayarsız olabilir. Staleness
 * hesabı cihaz saatine güvenemez — sunucu `server_ts`'i baz alınır.
 *
 *   offset = server_ts - client_received_ts   (EWMA α=0.1)
 *   server-uyumlu now = Date.now() + offset
 *   tick yaşı = now() - tick.server_ts
 *
 * Memory: decision_pwa_resilience.md §6 (time sync)
 */
class ClockSync {
    private _offset = 0;
    private _samples = 0;
    private readonly alpha = 0.1;

    /** Gateway'den server_ts geldiğinde çağrılır (initial_state veya tick). */
    observe(serverTs: number, clientReceivedTs: number = Date.now()): void {
        if (!Number.isFinite(serverTs)) return;
        const sample = serverTs - clientReceivedTs;
        if (this._samples === 0) {
            this._offset = sample;
        } else {
            this._offset = this.alpha * sample + (1 - this.alpha) * this._offset;
        }
        this._samples++;
    }

    /** Sunucu-uyumlu şimdi (epoch ms). */
    now(): number {
        return Date.now() + this._offset;
    }

    /** Bir tick'in yaşı (ms) — sunucu zaman çizelgesine göre. */
    ageMs(serverTs: number): number {
        return this.now() - serverTs;
    }

    get offset(): number {
        return this._offset;
    }

    get samples(): number {
        return this._samples;
    }
}

export const clockSync = new ClockSync();
